import Vue from 'vue'
import VueRouter from 'vue-router'
import { Trans } from './plugins/Translation'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter);

const Router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL ,
  beforeEnter: Trans.routeMiddleware,
  routes : [
    { 
      path: '*', 
      redirect: '/en' // @todo : detect if navigator language is part of the "supported languages" and redirect as needed
    },
    {
      path: '/:lang/scrollama-examples',
      name: 'scrollama-examples',
      component: () => import('./views/Story-Scrollama-examples.vue') , 
      children : [  
      ]
    },
    {
      path: '/:lang/',
      name: 'scrollama',
      component: () => import('./views/Story-Scrollama.vue') , 
      children : [  
      ]
    }

  ]
})

Router.beforeEach((to, from, next)=>{
  Trans.routeMiddleware(to, from, next) ; 
});

Router.afterEach((to,) => {
  let routing = to.path.split('/');
  delete routing[0] ; delete routing[1] ; 
  routing.filter(()=>{ return true })

  document.querySelector('html').className = routing.join(' ').trim(); 
}); 

export default Router ; 